import { render, staticRenderFns } from "./BookingSection.vue?vue&type=template&id=d60a1308&scoped=true&"
import script from "./BookingSection.vue?vue&type=script&lang=ts&"
export * from "./BookingSection.vue?vue&type=script&lang=ts&"
import style0 from "./BookingSection.vue?vue&type=style&index=0&id=d60a1308&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60a1308",
  null
  
)

export default component.exports